export { default } from './AddressAutocompleteCDS';
